"use client";
import { useState } from "react";
import Link from "next/link";
import { c } from "@/lib/vster/theme";
import Icon from "@/components/vster/Icon";

// 상단 필터 관점 전환 탭 — 산업·도메인 / 사업 분야. 각 탭 내용은 서버에서 렌더한 칩 행(Link)을 그대로 표시.
//   기본 탭은 initialTab(산업 도메인). 활성 필터가 사업분야면 서버가 initialTab='field' 로 넘겨 선택이 보이게 함.
type TabKey = "domain" | "field" | "region";
export default function FilterTabs({
  initialTab,
  domainNode,
  fieldNode,
  regionNode,
}: {
  initialTab: TabKey;
  domainNode: React.ReactNode;
  fieldNode: React.ReactNode;
  regionNode: React.ReactNode;
}) {
  const [tab, setTab] = useState<TabKey>(initialTab);

  const tabBtn = (key: TabKey, label: string, active: boolean) => (
    <button
      type="button"
      onClick={() => setTab(key)}
      style={{
        appearance: "none", background: "none", border: "none", cursor: "pointer",
        fontFamily: "inherit", fontSize: 14.5, fontWeight: active ? 700 : 600,
        color: active ? c.actionDark : c.muted, padding: "11px 18px", marginBottom: -1.5,
        borderBottom: active ? `2.5px solid ${c.action}` : "2.5px solid transparent",
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, borderBottom: `1.5px solid ${c.line}`, marginBottom: 16 }}>
        {tabBtn("domain", "산업·도메인", tab === "domain")}
        {tabBtn("field", "지원사업분류", tab === "field")}
        {tabBtn("region", "지역별", tab === "region")}
        <Link
          href={"/programs" as never}
          title="검색어·필터 초기화"
          style={{
            marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 5, textDecoration: "none",
            fontSize: 13, fontWeight: 600, color: c.muted, padding: "6px 12px", borderRadius: 8, border: `1px solid ${c.line}`, background: c.surface,
          }}
        >
          <Icon name="restart_alt" size={16} color={c.muted} />검색어 초기화
        </Link>
      </div>
      <div>{tab === "domain" ? domainNode : tab === "field" ? fieldNode : regionNode}</div>
    </div>
  );
}
